import { render, staticRenderFns } from "./customersChangeBlock.vue?vue&type=template&id=19bab8fd&scoped=true&"
import script from "./customersChangeBlock.vue?vue&type=script&lang=js&"
export * from "./customersChangeBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bab8fd",
  null
  
)

export default component.exports